import { databaseViewFilterFunctions } from '@streamlain/database-identity';

import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

export const numberFilter = [
  createFilter({
    name: 'equal',
    self: t.number.instance(),
    args: [t.number.instance()] as const,
    label: '=',
    shortString: v => (v ? ` = ${v.value}` : undefined),
    impl: databaseViewFilterFunctions.equal,
    defaultValue: args => args[0],
  }),
  createFilter({
    name: 'notEqual',
    self: t.number.instance(),
    args: [t.number.instance()] as const,
    label: '≠',
    shortString: v => (v ? ` ≠ ${v.value}` : undefined),
    impl: databaseViewFilterFunctions.notEqual,
  }),
  createFilter({
    name: 'greatThan',
    self: t.number.instance(),
    args: [t.number.instance()] as const,
    label: '>',
    shortString: v => (v ? ` > ${v.value}` : undefined),
    impl: databaseViewFilterFunctions.greatThan,
    defaultValue: args => args[0] + 1,
  }),
  createFilter({
    name: 'lessThan',
    self: t.number.instance(),
    args: [t.number.instance()] as const,
    label: '<',
    shortString: v => (v ? ` < ${v.value}` : undefined),
    impl: databaseViewFilterFunctions.lessThan,
    defaultValue: args => args[0] - 1,
  }),
  createFilter({
    name: 'greatThanOrEqual',
    self: t.number.instance(),
    args: [t.number.instance()] as const,
    label: '≥',
    shortString: v => (v ? ` ≥ ${v.value}` : undefined),
    impl: databaseViewFilterFunctions.greatThanOrEqual,
    defaultValue: args => args[0],
  }),
  createFilter({
    name: 'lessThanOrEqual',
    self: t.number.instance(),
    args: [t.number.instance()] as const,
    label: '≤',
    shortString: v => (v ? ` ≤ ${v.value}` : undefined),
    impl: databaseViewFilterFunctions.lessThanOrEqual,
    defaultValue: args => args[0],
  }),
];
